import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const LightbulbIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 12 16"
  >
    <path d="M6 2.5c-1.654 0-3 1.346-3 3a.5.5 0 1 0 1 0c0-1.103.898-2 2-2a.5.5 0 1 0 0-1M3.502 14.35c0 .098.029.193.084.275l.766 1.152a.5.5 0 0 0 .416.223h2.464a.5.5 0 0 0 .416-.223l.766-1.152a.5.5 0 0 0 .084-.276L8.499 13H3.501zM6 0C2.804 0 .5 2.593.5 5.5a5.47 5.47 0 0 0 1.361 3.618c.52.594 1.336 1.838 1.638 2.88V12H5v-.004q0-.225-.067-.44A9.9 9.9 0 0 0 2.99 8.13 4 4 0 0 1 2.002 5.5c-.007-2.301 1.864-4 3.998-4 2.206 0 4 1.794 4 4 0 .968-.351 1.902-.99 2.63a9.9 9.9 0 0 0-1.94 3.42q-.069.218-.07.447V12h1.5v-.002c.303-1.042 1.12-2.286 1.64-2.88A5.5 5.5 0 0 0 6 0" />
  </svg>
);
LightbulbIcon.id = 'LightbulbIcon';
LightbulbIcon.displayName = 'LightbulbIcon';
export default LightbulbIcon;
